
export const isEmptyNullUndefined = (value) => {
  // console.log('In isEmptyNullUndefined and typeof value is: ', typeof value, '.  Also, the value is: ', value)
  return value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
}